<template>
  <el-dialog :visible.sync="visible" :title="dialogTitle"  @close="resetForm" width="800px" :close-on-click-modal="false">
    <el-form ref="formRef" :model="form" label-position="right" label-width="100px">
      <template v-for="(field, index) in form.extraFields">
        <!-- text -->
        <el-form-item
          v-if="field.type === 'text'"
          :label="field.name"
          :key="index"
          :prop="`extraFields.${index}.value`"
          :rules="{
            required: true, message: '不能为空', trigger: 'blur'
          }"
        >
          <el-input v-model="field.value" placeholder="请输入" style="width: 300px;"></el-input>
        </el-form-item>
        <!-- select -->
        <el-form-item
          v-if="field.type === 'select'"
          :label="field.name"
          :prop="`extraFields.${index}.value`"
          :rules="{
            required: true, message: '不能为空', trigger: 'change'
          }"
        >
          <el-select v-model="field.value" placeholder="请选择">
            <el-option
              v-for="(item, index) in field.options"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- image -->
        <el-form-item
          v-if="field.type === 'image'"
          :label="field.name"
          :prop="`extraFields.${index}.value`"
          :rules="{
            required: true, message: '不能为空', trigger: 'change'
          }"
        >
          <el-upload
            class="avatar-uploader"
            action="/sh-rczx/cgi-bin/upload/file"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="(res, file) => onAvatarSuccess(res, file, index)"
          >
            <img v-if="field.value" :src="field.value" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
        <!-- date -->
        <el-form-item
          v-if="field.type === 'date'"
          :label="field.name"
          :prop="`extraFields.${index}.value`"
          :rules="{
            required: true, message: '不能为空', trigger: 'change'
          }"
        >
          <el-date-picker
            v-model="field.value"
            type="date"
            placeholder="请选择日期">
          </el-date-picker>
        </el-form-item>
        <!-- time -->
        <el-form-item
          v-if="field.type === 'time'"
          :label="field.name"
          :prop="`extraFields.${index}.value`"
          :rules="{
            required: true, message: '不能为空', trigger: 'change'
          }"
        >
          <el-time-picker
            v-model="field.value"
            placeholder="请选择时间">
          </el-time-picker>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deliverSignData } from '@/api/exam.js'

export default {
  name: 'DialogExtraFields',
  data() {
    return {
      loading: false,
      visible: true,
      dialogTitle: '额外信息',
      form: {
        recruitId: null,
        resumeId: null,
        handSignature: null,
        extraFields: [],
      }
    }
  },
  mounted() {},
  methods: {
    init(props) {
      this.$refs['formRef'].resetFields()
      if (props) {
        this.form.recruitId = props.recruitId
        this.form.resumeId = props.resumeId
        this.form.handSignature = props.handSignature
        this.form.extraFields = props.otherField.map(function(item, index) {
          if (item.type === 'select') {
            // 创建一个新的对象并初始化 options
            let otherFieldItem = {
              ...item,
              value: '',
              prop: `${item.type}${index}`,
              options: item.option.split('、').map(i => ({
                label: i,
                value: i
              }))
            };
            return otherFieldItem;
          } else if (item.type === 'image') {
            let otherFieldItem = {
              ...item,
              value: '',
              prop: `${item.type}${index}`,
              imageList: []
            };
            return otherFieldItem;
          }
          return { ...item, prop: `${item.type}${index}`, value: '' };
        })
      }
      this.$nextTick(() => {
        this.visible = true
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleConfirm() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          if (!this.form.recruitId) {
            this.$message.error('岗位ID不能为空');
            return;
          }
          if (!this.form.resumeId) {
            this.$message.error('简历ID不能为空');
            return;
          }
          // if (!this.form.handSignature) {
          //   this.$message.error('电子签名不能为空');
          //   return;
          // }
          this.$confirm('是否确定投递简历?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true;
            const params = {
              recruitId: this.form.recruitId,
              resumeId: this.form.resumeId,
              handSignature: this.form.handSignature,
              otherFieldValue: this.form.extraFields.map(item => ({
                name: item.name,
                value: item.value
              }))
            }
            deliverSignData(params).then((res) => {
              if (res && res.status === 200) {
                this.$message.success('投递成功');
              } else {
                this.$message.error(res.message);
              }
            }).catch((err) => {
              console.log(err)
            }).finally(() => {
              this.loading = false;
              this.visible = false;
            })
          })
        }
      })
    },
    resetForm() {
      this.$refs['formRef'].resetFields()
    },
    beforeAvatarUpload(file) {
      const isType = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLimit = file.size / 1024 / 1024 < 5
      if (!isType) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLimit) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isType && isLimit
    },
    onAvatarSuccess(res, file, index) {
      if (res && res.status === 200) {
        this.form.extraFields[index].value = res.result.route
      } else {
        this.$message.error(res.message)
      }
    }
  }
}
</script>

<style scoped>
</style>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  object-fit: contain;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/DialogExtraFields/index.vue